import React, { ReactElement, useState, ChangeEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { RichTextEditor } from '@mantine/rte'
import {
  PopUp,
  EditCard,
  StyledIcon,
  StyledInputs,
  StyledInput,
} from '../../styled-components'

import { TrainingGroup } from '../../../../types/training'
import Icon from '../../../icon'
import { Alert } from '../../../../constants/sweet-alert'
import Inputfield from '../../../input/input-field'
import Button from '../../../button'
import { updateTrainingGroup } from '../../../../api/training-group'

interface TrainingGroupsAddEditProps {
  trainingsGroup: TrainingGroup
  onClose: () => void
}

const TrainingGroupsAddEdit = ({
  trainingsGroup,
  onClose,
}: TrainingGroupsAddEditProps): ReactElement => {
  const [title, setTitle] = useState(trainingsGroup?.title)
  const [text, setText] = useState(trainingsGroup?.text)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const onEditSave = () => {
    const payload = {
      title,
      text,
    }
    setLoading(true)
    updateTrainingGroup(trainingsGroup.id, payload).then((status) => {
      if (status === 200) {
        setLoading(false)

        Alert.fire({
          icon: 'success',
          title: `Updated`,
        })
        navigate(0)
      } else {
        setLoading(false)

        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
    })
  }

  return (
    <PopUp>
      <EditCard>
        <StyledIcon onClick={onClose}>
          <Icon name={'cil:x'} color="darkRed" width={20} height={20} />
        </StyledIcon>

        <StyledInputs>
          <StyledInput>
            <Inputfield
              value={title}
              labelName="العنوان"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setTitle(event.target.value)
              }
              type="text"
            />
          </StyledInput>
        </StyledInputs>
        <RichTextEditor dir="rtl" value={text} onChange={setText} />
        <Button loading={loading} onClick={onEditSave} color="red">
          <Icon name="entypo:check" />
        </Button>
      </EditCard>
    </PopUp>
  )
}

export default TrainingGroupsAddEdit
